var _link, _style, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfColorado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1800,
    height: 1200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M0 0h1800v1200H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 400h1800v400H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.81,750A400,400 0 1,1 1130.81,450L760,600",
    fill: "#BF0A30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 600,
    r: 200,
    fill: "gold"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfColorado);
export default __webpack_public_path__ + "static/media/Flag_of_Colorado.455bb4350c4cbee668ead0235a3101e4.svg";
export { ForwardRef as ReactComponent };